import { SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';

export default function XColored(props: Partial<SVGProps<any>> & {dark?: boolean, keepOriginal?: boolean}) {
  const { dark, keepOriginal, ...spreadProps} = props;
  return (
<div {...spreadProps} className={twMerge('grid place-items-center',spreadProps.className)}>
<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path fillRule="evenodd" clipRule="evenodd" d="M8.49233 11.12L1 2H6.93445L11.5594 7.63682L16.5004 2.02538H19.7688L13.1397 9.56284L21 19.1429H15.0833L10.0754 13.047L4.72896 19.126H1.44287L8.49233 11.12ZM15.9457 17.4531L4.63881 3.68978H6.07138L17.364 17.4531H15.9457Z" className={twMerge("fill-[#001C3C] dark:fill-white", !props.keepOriginal && 'dark:fill-white')}/>
</svg>
    </div>
  )
}